import AppModal from "../../AppModal"
import { IconButton, MailchimpSubscribeForm } from '../../';
import MintModalHeader from './MintModalHeader'
import MintModalChoice from './MintModalChoice'
import { MAILCHIMP_URL, BASEJUMP_CONTRACT_ADDRESS } from '../../../constants';
import { openUrl } from '../../../utils'; 
import {
  useNavigate
} from "react-router-dom";
import { 
  StyledMintModal,
  ModalContentBackground,
  ModalContentHolder,
  ButtonContent,
  SelectedText,
  Content
} from "./MintModal.styled"
import BasejumpContractAbi from '../../../contract.abi'
import { 
  MintModalPhaseOne,
} from "./MintModalPhaseOne.styled"
import React, { useContext } from "react"
import { AppContext } from "../../../providers/AppContext"
import useIsMobile from '../../../hooks/useIsMobile';

import MailchimpSubscribe from "react-mailchimp-subscribe"

import { parseEventLogs } from 'viem'

const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

const MintCompleteModal = ({ receipt }) => {
  const navigate = useNavigate();
  const { setCompleteReceipt } = useContext(AppContext);
  const isMobile = useIsMobile();

  const onClickApp = () => {
    setCompleteReceipt(null);
    navigate('/app');
  }

  const logs = parseEventLogs({
    abi: BasejumpContractAbi, 
    logs: receipt.logs,
  });

  const transferLog = logs.find(l => l.eventName === 'Transfer' && l.args.from === '0x0000000000000000000000000000000000000000');
  const tokenId = transferLog ? parseInt(transferLog.args.tokenId) : null;
  const openseaUrl = IS_PRODUCTION
    ? `https://opensea.io/assets/base/${BASEJUMP_CONTRACT_ADDRESS}/${tokenId}`
    : `https://testnets.opensea.io/assets/base-sepolia/${BASEJUMP_CONTRACT_ADDRESS}/${tokenId}`;

  return (
    <AppModal>
      <StyledMintModal>
        <MintModalHeader title='Congratulations'/>
        <ModalContentBackground>
          <MintModalPhaseOne>
            <ModalContentHolder>
              <Content>
                Your Action Figures are in <SelectedText>your wallet</SelectedText>!
              </Content>
            </ModalContentHolder>
            {tokenId && <>
              <ModalContentHolder>
                <IconButton onClick={() => openUrl(openseaUrl)} animated={true}>
                  <ButtonContent>
                    <div>Show on Opensea</div>
                    <img style={{paddingBottom: '6px'}} src='/assets/arrow.svg' alt=""/>
                  </ButtonContent>
                </IconButton>
              </ModalContentHolder>
	      {!isMobile && <MintModalChoice label='Or'/>}
            </>}
            {!isMobile && <ModalContentHolder>
              <IconButton
                onClick={onClickApp}
                animated={true}
                borderOverwrite='rgba(0, 0, 0, .16)'
                borderOverwriteHover='rgba(0, 0, 0, .32)'
                backgroundOverwrite='white'>
                <ButtonContent>
                  <div>Open App</div>
                  <img style={{paddingBottom: '6px'}} src='/assets/bj.svg' alt=""/>
                </ButtonContent>
              </IconButton>
            </ModalContentHolder>}
            <ModalContentHolder>
              <Content style={{fontSize: '1.25rem'}}>
                ACTION FIGURES CAN EARN AND UNLOCK ACTION + SPECIAL ITEMS IN BASEJUMP
              </Content>
            </ModalContentHolder>
            <MintModalChoice label='Subscribe for the launch updates'/>
            <ModalContentHolder>
              <MailchimpSubscribe
                url={MAILCHIMP_URL}
                render={({ subscribe, status, message }) => (<MailchimpSubscribeForm subscribe={subscribe} status={status} message={message} />)}
              />
            </ModalContentHolder>
          </MintModalPhaseOne>
        </ModalContentBackground>
      </StyledMintModal>      
    </AppModal>
  )
}

export default MintCompleteModal
